class ExpandingArea {
  constructor (el) {
    this.dom = el
    this.appendEvtListeners()
    this.setStyle(true)
  }

  setStyle (auto) {
    if (auto) {
      this.dom.style.height = 'auto'
    }
    this.dom.style.height = Math.min(this.dom.scrollHeight, 40) + 'px'
  }

  delayedResize () {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.timer = setTimeout(function () {
      self.setStyle()
    }, 200)
  }

  appendEvtListeners () {
    const el = this.dom
    const self = this

    if (el.addEventListener) {
      el.addEventListener('keyup', function (e) {
        if (e.keyCode) {
          self.setStyle(true)
        }
      }, false)
      el.addEventListener('input', function (e) {
        self.setStyle(true)
      }, false)
      self.setStyle()
    } else if (el.attachEvent) {
      el.attachEvent('onpropertychange', function () {
        self.setStyle()
      })
      self.setStyle()
    }
    if (window.VBArray && window.addEventListener) { // IE9
      el.attachEvent('onkeydown', function () {
        var key = window.event.keyCode
        if (key === 8 || key === 46 || key === 13) self.delayedResize()
      })
      el.attachEvent('oncut', function () {
        self.delayedResize()
      }) // 处理粘贴
    }
  }
}

export default ExpandingArea
